var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('window',{ref:"window",attrs:{"size":"md","title":"Spezialwerkzeuge"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var data = ref.data;
return [_c('ul',_vm._l((data),function(tool){return _c('li',{key:tool.id},[_vm._v("\n        "+_vm._s(tool.name)+"\n      ")])}),0)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }